<template>
  <v-row  class="progressbar__row" justify="center" align="center">
    <v-container fluid>
      <v-progress-linear background-opacity="0.3" :height="height" :value="value" :color="color"></v-progress-linear>
    </v-container>
  </v-row>
</template>

<script>
// @group Common
// Styled ProgressLinear component

export default {
  name: 'ProgressLinear',
  props: {
    //has height 
    height: {
      // `Number` 
      type: Number,
         // The default value is: `5`
      default: 5
    },
    //has value
    value: {
         // `Number` 
      type: Number,
         // The default value is: `0`
        default: 0
    },
    //has default color
    color: {
      // `String` 
        type: String,
        // The default value is: `light-blue`
        default: 'light-blue'
    },
  }
}
</script>

<style>

</style>